import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c04d5102"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "" }

import { Promotion } from "@element-plus/icons-vue";
import { upgradeAccount } from "@/utils";


export default /*#__PURE__*/_defineComponent({
  __name: 'EmailConnect',
  props: {
  showVisitorSurvey: {
    type: Function,
    required: false,
  },
},
  setup(__props) {

const $props = __props;



async function open() {
  // if (upgradeAccount()) return;
  let { status } = await upgradeAccount();
  if (status === "confirm") {
    $props.showVisitorSurvey && $props.showVisitorSurvey("confirm");
    return; 
  }
  if(status === 'cancel'|| status === 'close'){ 
    return
  }
  const email = document.createElement("a");
  email.target = "_blank";
  email.href = "mailto:cnobi-qa@bytedance.com";
  email.click();
}

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_tooltip, {
      class: "box-item",
      effect: "dark",
      content: _ctx.$t('客诉通道'),
      placement: "left"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "icon g-flex-jc-center g-flex-al-center g-pointer",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (open()))
        }, [
          _createVNode(_component_el_icon, { size: "25" }, {
            default: _withCtx(() => [
              _createVNode(_unref(Promotion))
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["content"])
  ]))
}
}

})